import ScriptWorkspace from '../common/ScriptWorkspace';

export default function ScriptDetailPage() {
  return (
    <ScriptWorkspace
      scriptsIndexPath="/agency/scripts"
      breadcrumbScriptsLabel="Scripts"
      headerBackUsesHistory
    />
  );
}
